import { logger } from "@/utils/logger";
import { resolveMethodKey } from "./analysis.bridge";
import { syncServiceBitis } from "./planBuilders";
/** Servis / parkur düzenleme aksiyonları (updateService, updateParkurSuresi korunur) */
export const frequencyServiceActions = {
    /** Vuex: SET_BASE_PLANS */
    setBasePlans(plans) {
        this.basePlans = plans;
        this.activePlans = JSON.parse(JSON.stringify(plans));
    },
    /** Vuex: SET_CURRENT_PLAN_TYPE */
    setCurrentPlanType(planType) {
        if (planType !== "service" && planType !== "vehicle") {
            logger.error(`Geçersiz plan türü: ${planType}`);
            return;
        }
        logger.debug(`Plan türü değişti: ${this.currentPlanType} -> ${planType}`);
        this.currentPlanType = planType;
    },
    /** Vuex: SET_VEHICLE_PLAN */
    setVehiclePlan({ methodKey, plan }) {
        this.vehiclePlans[methodKey] = plan;
    },
    /** Vuex: UPDATE_PARKUR_SURESI — aktif plandaki ilgili saatteki tüm servislerin süresini günceller */
    updateParkurSuresi({ saat, yon, sure, methodKey: methodKeyArg }) {
        const methodKey = methodKeyArg || resolveMethodKey();
        if (!methodKey || !this.activePlans[methodKey]?.[yon]) {
            logger.warn("updateParkurSuresi: geçersiz methodKey veya yön", {
                methodKey,
                yon,
            });
            return;
        }
        const saatKey = `${String(saat).padStart(2, "0")}_0`;
        const parkurKey = `${saatKey}_${yon}`;
        const hour = parseInt(saat, 10);
        this.userModifications[methodKey].parkurSureleri[parkurKey] = sure;
        const modifiedServices = this.userModifications[methodKey].modifiedServices;
        let affectedCount = 0;
        const updatedList = this.activePlans[methodKey][yon].map((servis) => {
            const servisSaati = parseInt(servis.baslangic.split(":")[0], 10);
            if (servisSaati !== hour)
                return servis;
            affectedCount += 1;
            const synced = syncServiceBitis({ ...servis, sure });
            const existingIndex = modifiedServices.findIndex((s) => s.id === synced.id);
            if (existingIndex !== -1) {
                modifiedServices[existingIndex] = synced;
            }
            else {
                modifiedServices.push(synced);
            }
            return synced;
        });
        this.activePlans[methodKey][yon] = updatedList;
        logger.debug(`Parkur süresi güncelleniyor - ${yon} yönü, saat ${saat}, süre ${sure} dk`);
        logger.debug(`${affectedCount} servis etkilenecek`);
        try {
            const currentParkurSureleri = JSON.parse(localStorage.getItem("currentParkurSureleri") || "{}");
            if (!currentParkurSureleri[yon]) {
                currentParkurSureleri[yon] = {};
            }
            currentParkurSureleri[yon][saatKey] = sure;
            localStorage.setItem("currentParkurSureleri", JSON.stringify(currentParkurSureleri));
        }
        catch (error) {
            logger.error("LocalStorage parkur süresi güncelleme hatası:", error);
        }
    },
    /** Saat dilimi parkur süresini orijinale döndürür (kullanıcı modifikasyonundan siler) */
    resetParkurSuresi({ saat, yon, originalSure, methodKey: methodKeyArg }) {
        const methodKey = methodKeyArg || resolveMethodKey();
        if (!methodKey || !this.activePlans[methodKey]?.[yon]) {
            logger.warn("resetParkurSuresi: geçersiz methodKey veya yön", {
                methodKey,
                yon,
            });
            return;
        }
        const saatKey = `${String(saat).padStart(2, "0")}_0`;
        const parkurKey = `${saatKey}_${yon}`;
        const hour = parseInt(saat, 10);
        delete this.userModifications[methodKey].parkurSureleri[parkurKey];
        const modifiedServices = this.userModifications[methodKey].modifiedServices;
        let affectedCount = 0;
        const updatedList = this.activePlans[methodKey][yon].map((servis) => {
            const servisSaati = parseInt(servis.baslangic.split(":")[0], 10);
            if (servisSaati !== hour)
                return servis;
            affectedCount += 1;
            const synced = syncServiceBitis({ ...servis, sure: originalSure });
            const existingIndex = modifiedServices.findIndex((s) => s.id === synced.id);
            if (existingIndex !== -1) {
                modifiedServices[existingIndex] = synced;
            }
            else {
                modifiedServices.push(synced);
            }
            return synced;
        });
        this.activePlans[methodKey][yon] = updatedList;
        logger.debug(`Parkur süresi sıfırlandı - ${yon} yönü, saat ${saat}, süre ${originalSure} dk (${affectedCount} servis)`);
        try {
            const currentParkurSureleri = JSON.parse(localStorage.getItem("currentParkurSureleri") || "{}");
            if (!currentParkurSureleri[yon]) {
                currentParkurSureleri[yon] = {};
            }
            currentParkurSureleri[yon][saatKey] = originalSure;
            localStorage.setItem("currentParkurSureleri", JSON.stringify(currentParkurSureleri));
        }
        catch (error) {
            logger.error("LocalStorage parkur süresi sıfırlama hatası:", error);
        }
    },
    /** Vuex: ADD_SERVICE */
    addService({ service, methodKey }) {
        logger.debug("ADD_SERVICE mutation tetiklendi:", service, methodKey);
        this.userModifications[methodKey].addedServices.push({ ...service });
        this.activePlans[methodKey][service.yon].push({ ...service });
    },
    /** Vuex: REMOVE_SERVICE */
    removeService({ serviceId, methodKey }) {
        logger.debug("REMOVE_SERVICE mutation tetiklendi:", serviceId, methodKey);
        const yon = serviceId.startsWith("gidis") ? "gidis" : "donus";
        const serviceIndex = this.activePlans[methodKey][yon].findIndex((s) => s.id === serviceId);
        if (serviceIndex === -1)
            return;
        this.userModifications[methodKey].removedServices.push(serviceId);
        this.activePlans[methodKey][yon].splice(serviceIndex, 1);
    },
    /**
     * Araç planından araç tipi değişince Pinia servis + vehiclePlans günceller.
     * Vuex vehicleAssignment güncellemesinden sonra çağrılır (tek kaynak: Pinia).
     */
    persistVehicleTypeFromVehiclePlan({ vehicleId, newType, methodKey: methodKeyArg, vehicles, assignments, }) {
        const methodKey = methodKeyArg || resolveMethodKey();
        if (!methodKey || vehicleId == null || !newType) {
            return false;
        }
        const plan = this.activePlans[methodKey];
        if (!plan) {
            return false;
        }
        const vehicleAssignments = (assignments || []).filter((a) => String(a.arac_id) === String(vehicleId));
        for (const assignment of vehicleAssignments) {
            for (const yon of ["gidis", "donus"]) {
                const list = plan[yon] || [];
                const svc = list.find((s) => String(s.id) === String(assignment.sefer_id));
                if (svc) {
                    this.updateService({
                        methodKey,
                        service: {
                            ...svc,
                            yon,
                            arac_tipi: newType,
                            original_arac_tipi: svc.original_arac_tipi || svc.arac_tipi,
                        },
                    });
                    break;
                }
            }
        }
        const vehiclesWithAssignments = (vehicles || []).map((v) => ({
            ...v,
            assignments: (assignments || []).filter((a) => String(a.arac_id) === String(v.id)),
        }));
        this.setVehiclePlan({ methodKey, plan: vehiclesWithAssignments });
        this.saveStateToPersistence();
        return true;
    },
    /** Vuex: UPDATE_SERVICE */
    updateService({ service, methodKey }) {
        const yon = service.yon;
        const serviceIndex = this.activePlans[methodKey][yon].findIndex((s) => s.id === service.id);
        if (serviceIndex === -1) {
            logger.warn(`ID'si ${service.id} olan servis bulunamadı`);
            return;
        }
        logger.debug(`${service.id} servisi güncelleniyor, yeni araç tipi: ${service.arac_tipi}`);
        const existingIndex = this.userModifications[methodKey].modifiedServices.findIndex((s) => s.id === service.id);
        const synced = syncServiceBitis({ ...service });
        if (existingIndex !== -1) {
            this.userModifications[methodKey].modifiedServices[existingIndex] =
                synced;
        }
        else {
            this.userModifications[methodKey].modifiedServices.push(synced);
        }
        this.activePlans[methodKey][yon][serviceIndex] = synced;
    },
    /** Vuex: UPDATE_SERVICES_BY_METHOD */
    updateServicesByMethod({ methodKey, direction, services }) {
        if (!methodKey || !direction || !services || !Array.isArray(services)) {
            logger.error("UPDATE_SERVICES_BY_METHOD için geçersiz parametreler", { methodKey, direction, services });
            return;
        }
        logger.debug(`${methodKey} metodunun ${direction} yönündeki servisleri toplu olarak güncelleniyor (${services.length} servis)`);
        this.activePlans[methodKey][direction] = [...services];
        services.forEach((service) => {
            if (!service.id)
                return;
            const modifiedServices = this.userModifications[methodKey].modifiedServices;
            const existingIndex = modifiedServices.findIndex((s) => s.id === service.id);
            if (existingIndex !== -1) {
                this.userModifications[methodKey].modifiedServices[existingIndex] = {
                    ...service,
                };
            }
            else {
                this.userModifications[methodKey].modifiedServices.push({
                    ...service,
                });
            }
        });
    },
    /** Vuex: SET_NEEDS_REFRESH */
    setNeedsRefresh(needsRefresh) {
        this.needsRefresh = needsRefresh;
    },
    /** Vuex: UPDATE_ACTIVE_PLAN */
    updateActivePlan({ methodKey, plan }) {
        if (!this.activePlans[methodKey]) {
            this.activePlans[methodKey] = { gidis: [], donus: [] };
        }
        this.activePlans[methodKey] = plan;
    },
    /** Vuex: CLEAR_ALL_ACTIVE_PLANS */
    clearAllActivePlans() {
        Object.keys(this.activePlans).forEach((methodKey) => {
            this.activePlans[methodKey] = { gidis: [], donus: [] };
        });
        Object.keys(this.vehiclePlans).forEach((methodKey) => {
            this.vehiclePlans[methodKey] = [];
        });
    },
    /** Vuex: RESET_SERVICE_VEHICLE_TYPES */
    resetServiceVehicleTypes() {
        ["basePlans", "activePlans"].forEach((planType) => {
            Object.keys(this[planType]).forEach((methodKey) => {
                if (this[planType][methodKey].gidis &&
                    this[planType][methodKey].gidis.length) {
                    this[planType][methodKey].gidis = this[planType][methodKey].gidis.map((service) => ({
                        ...service,
                        arac_tipi: service.original_arac_tipi || "SOLO",
                    }));
                }
                if (this[planType][methodKey].donus &&
                    this[planType][methodKey].donus.length) {
                    this[planType][methodKey].donus = this[planType][methodKey].donus.map((service) => ({
                        ...service,
                        arac_tipi: service.original_arac_tipi || "SOLO",
                    }));
                }
            });
        });
        logger.debug("Servis planlarındaki araç tipleri sıfırlandı");
    },
    /** Vuex: RESET_USER_MODIFICATIONS */
    resetUserModifications() {
        Object.keys(this.userModifications).forEach((methodKey) => {
            this.userModifications[methodKey] = {
                parkurSureleri: {},
                addedServices: [],
                removedServices: [],
                modifiedServices: [],
            };
        });
        logger.debug("Kullanıcı değişiklikleri temizlendi");
    },
};
